/**
 * Single source of truth for brand-level display strings.
 * Consumed by web, mobile, and Cloud Functions email templates.
 * Changing a value here changes it everywhere.
 */
export const BRAND = {
  /** Display name used in all prose */
  name: "RevHead Pro",
  /** Tighter form when space is short (push titles, narrow UI) */
  nameShort: "RevHead",
  /** Placeholder — final tagline pending Oscar's pick from plan 13b §A.2 */
  tagline: "Your garage, your meets, your rides.",
  /** Primary domain, no scheme */
  domain: "revhead.pro",
  /** Primary URL with scheme, no trailing slash */
  url: "https://revhead.pro",
  /** Public support address */
  supportEmail: "support@revhead.pro",
  /** Help desk address (used by support Cloud Function) */
  helpEmail: "gethelp@revhead.pro",
  /** Firebase Auth + SendGrid From header */
  fromEmail: "RevHead Pro <noreply@revhead.pro>",
} as const;

export type Brand = typeof BRAND;
